const parseSnakeCase = (value: string) => value.split('_').join(' ')?.toLowerCase();

export const parseSnakeUppercaseToNormal = (value: string) => {
  const parsedString = parseSnakeCase(value);

  return parsedString?.replace(/(^\w{1})|(\s+\w{1})/g, (letter) => letter?.toUpperCase());
};
